module.exports = __webpack_public_path__ + "static/media/vase.28484b79.png";